/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Showcase_Concierge_DescriptionInputs */

const en_meta_showcase_concierge_description = /** @type {(inputs: Meta_Showcase_Concierge_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An AI hotel concierge that answers property questions, suggests stays and completes bookings in plain language. Try the live demo on any device.`)
};

const lv_meta_showcase_concierge_description = /** @type {(inputs: Meta_Showcase_Concierge_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI konsjeržs dabiskā valodā atbild uz viesu jautājumiem, iesaka numurus un pabeidz rezervāciju. Izmēģiniet demonstrāciju un apskatiet, kā tas darbojas ikdienā.`)
};

/**
* | output |
* | --- |
* | "An AI hotel concierge that answers property questions, suggests stays and completes bookings in plain language. Try the live demo on any device." |
*
* @param {Meta_Showcase_Concierge_DescriptionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const meta_showcase_concierge_description = /** @type {((inputs?: Meta_Showcase_Concierge_DescriptionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Showcase_Concierge_DescriptionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_meta_showcase_concierge_description(inputs)
	return en_meta_showcase_concierge_description(inputs)
});